import { Package } from 'pages/newSubscription/models';
import { ISchoolDetails } from 'pages/subscribe/models';
import { Store } from './rootReducer';

/*STATE*/
export type State = {
  acceptCookies: boolean;
  accessibilityMode: boolean;
  mobileMenuOpen: boolean;
  toastStatus: { open: boolean; message: string };
  selectedPackages: Package[];
  validPromoCode: string;
  blogIds: number[];
  caseStudiesIds: number[];
  subscriptionPrice: {
    price: number;
    vat: number;
    total: number;
    vatRate: number;
    discount: number;
    discountType: string;
  };
  updateUsersList: boolean;
  schoolDetails: ISchoolDetails | null;
  registrationToken: string;
  poNumber: string;
  FinanceEmail: string;
};

export const initialState: State = {
  accessibilityMode: false,
  acceptCookies: false,
  mobileMenuOpen: false,
  toastStatus: { open: false, message: '' },
  selectedPackages: [],
  validPromoCode: '',
  blogIds: [],
  caseStudiesIds: [],
  subscriptionPrice: {
    price: 0,
    vat: 0,
    total: 0,
    vatRate: 0,
    discount: 0,
    discountType: '',
  },
  poNumber: '',
  FinanceEmail: '',
  updateUsersList: true,
  schoolDetails: null,
  registrationToken: '',
};

/* ACTIONS */
export enum GeneralAction {
  TOGGLE_MOBILE_MENU = 'app/TOGGLE_MOBILE_MENU',
  ACCEPT_COOKIES = 'app/ACCEPT_COOKIES',
  TOGGLE_ACCESSIBILITY_MODE = 'app/TOGGLE_ACCESSIBILITY_MODE',
  TOGGLE_TOAST = 'app/TOGGLE_TOAST',
}

export enum PricingAction {
  SELECT_PACKAGES = 'app/SELECT_PACKAGES',
  SET_VALID_PROMO_CODE = 'app/SET_VALID_PROMO_CODE',
  CLEAR_SELECTED_PACKAGE = 'app/CLEAR_SELECTED_PACKAGE',
  SET_PO_NUMBER = 'app/SET_PO_NUMBER',
  CLEAR_PO_NUMBER = 'app/CLEAR_PO_NUMBER',
  SET_FINANCE_EMAIL = 'app/SET_FINANCE_EMAIL',
  CLEAR_FINANCE_EMAIL = 'app/CLEAR_FINANCE_EMAIL',  
}

export enum BlogAction {
  SET_BLOG_IDS = 'app/SET_BLOG_IDS',
}

export enum CaseStudyAction {
  SET_CASE_STUDIES_IDS = 'app/SET_CASE_STUDIES_IDS',
}

export enum SubscribeAction {
  SET_PRICE = 'app/SET_PRICE',
  SET_SCHOOL_DETAILS = 'app/SET_SCHOOL_DETAILS',
  CLEAR_SCHOOL_DETAILS = 'app/CLEAR_SCHOOL_DETAILS',
  SET_REGISTRATION_TOKEN = 'app/SET_REGISTRATION_TOKEN',
}

export enum ManageUsersAction {
  SET_UPDATE_USERS_LIST = 'app/SET_USERS_LIST',
}

export type Action =
  | { type: GeneralAction.TOGGLE_MOBILE_MENU }
  | { type: GeneralAction.ACCEPT_COOKIES }
  | { type: GeneralAction.TOGGLE_ACCESSIBILITY_MODE }
  | {
      type: GeneralAction.TOGGLE_TOAST;
      payload: { open: boolean; message: string };
    }
  | { type: PricingAction.SELECT_PACKAGES; payload: Package[] }
  | { type: PricingAction.CLEAR_SELECTED_PACKAGE }
  | { type: PricingAction.SET_VALID_PROMO_CODE; payload: string }
  | { type: PricingAction.SET_PO_NUMBER; payload: string }
  | { type: PricingAction.CLEAR_PO_NUMBER }
  | { type: PricingAction.SET_FINANCE_EMAIL; payload: string }
  | { type: PricingAction.CLEAR_FINANCE_EMAIL }  
  | { type: BlogAction.SET_BLOG_IDS; payload: number[] }
  | { type: CaseStudyAction.SET_CASE_STUDIES_IDS; payload: number[] }
  | {
      type: SubscribeAction.SET_PRICE;
      payload: {
        price: number;
        vat: number;
        total: number;
        vatRate: number;
        discount: number;
        discountType: string;
      };
    }
  | { type: SubscribeAction.SET_SCHOOL_DETAILS; payload: ISchoolDetails }
  | { type: SubscribeAction.CLEAR_SCHOOL_DETAILS }
  | { type: SubscribeAction.SET_REGISTRATION_TOKEN; payload: string }
  | { type: ManageUsersAction.SET_UPDATE_USERS_LIST; payload: boolean };

export const misc = (state = initialState, action: Action): State => {
  switch (action.type) {
    case GeneralAction.TOGGLE_MOBILE_MENU:
      return {
        ...state,
        mobileMenuOpen: !state.mobileMenuOpen,
      };
    case GeneralAction.ACCEPT_COOKIES:
      return {
        ...state,
        acceptCookies: true,
      };
    case GeneralAction.TOGGLE_ACCESSIBILITY_MODE:
      return {
        ...state,
        accessibilityMode: !state.accessibilityMode,
      };
    case GeneralAction.TOGGLE_TOAST:
      return {
        ...state,
        toastStatus: action.payload,
      };
    case PricingAction.SELECT_PACKAGES:
      return {
        ...state,
        selectedPackages: action.payload,
      };
    case PricingAction.CLEAR_SELECTED_PACKAGE:
      return {
        ...state,
        selectedPackages: [],
      };
    case PricingAction.SET_VALID_PROMO_CODE:
      return {
        ...state,
        validPromoCode: action.payload,
      };
    case PricingAction.SET_PO_NUMBER:
      return {
        ...state,
        poNumber: action.payload,
      };
    case PricingAction.CLEAR_PO_NUMBER:
      return {
        ...state,
        poNumber: '',
      };
    case PricingAction.SET_FINANCE_EMAIL:
      return {
        ...state,
        FinanceEmail: action.payload,
      };
    case PricingAction.CLEAR_FINANCE_EMAIL:
      return {
        ...state,
        FinanceEmail: '',
      };      
    case BlogAction.SET_BLOG_IDS:
      return {
        ...state,
        blogIds: action.payload,
      };
    case CaseStudyAction.SET_CASE_STUDIES_IDS:
      return {
        ...state,
        caseStudiesIds: action.payload,
      };
    case SubscribeAction.SET_PRICE:
      return {
        ...state,
        subscriptionPrice: action.payload,
      };
    case SubscribeAction.SET_SCHOOL_DETAILS:
      return {
        ...state,
        schoolDetails: action.payload,
      };
    case SubscribeAction.CLEAR_SCHOOL_DETAILS:
      return {
        ...state,
        schoolDetails: null,
      };
    case SubscribeAction.SET_REGISTRATION_TOKEN:
      return {
        ...state,
        registrationToken: action.payload,
      };
    case ManageUsersAction.SET_UPDATE_USERS_LIST:
      return {
        ...state,
        updateUsersList: action.payload,
      };
    default:
      return state;
  }
};

// Action creatorse

export const clearPackageForm = (): Action => ({
  type: PricingAction.CLEAR_SELECTED_PACKAGE,
});

export const updateSelectedPackages = (payload: Package[]): Action => ({
  type: PricingAction.SELECT_PACKAGES,
  payload,
});

export const setValidPromoCode = (payload: string): Action => ({
  type: PricingAction.SET_VALID_PROMO_CODE,
  payload,
});

export const setPoNumber = (payload: string): Action => ({
  type: PricingAction.SET_PO_NUMBER,
  payload,
});

export const clearPoNumber = (): Action => ({
  type: PricingAction.CLEAR_PO_NUMBER,
});

export const setFinanceEmail = (payload: string): Action => ({
  type: PricingAction.SET_FINANCE_EMAIL,
  payload,
});

export const clearFinanceEmail = (): Action => ({
  type: PricingAction.CLEAR_FINANCE_EMAIL,
});

export const setUpdateUsersList = (payload: boolean): Action => ({
  type: ManageUsersAction.SET_UPDATE_USERS_LIST,
  payload,
});

export const setPrice = (payload: {
  price: number;
  vat: number;
  total: number;
  vatRate: number;
  discount: number;
  discountType: string;
}): Action => ({
  type: SubscribeAction.SET_PRICE,
  payload,
});
export const setSchoolDetails = (payload: ISchoolDetails): Action => ({
  type: SubscribeAction.SET_SCHOOL_DETAILS,
  payload,
});

export const clearSchoolDetails = (): Action => ({
  type: SubscribeAction.CLEAR_SCHOOL_DETAILS,
});

export const setRegistrationToken = (payload: string): Action => ({
  type: SubscribeAction.SET_REGISTRATION_TOKEN,
  payload,
});

export const toogleToast = (payload: {
  open: boolean;
  message: string;
}): Action => ({
  type: GeneralAction.TOGGLE_TOAST,
  payload,
});

// Selectors

export const selectMobileMenuOpen = (store: Store) => store.misc.mobileMenuOpen;
export const selectAccessibilityMode = (store: Store) =>
  store.misc.accessibilityMode;
export const selectSelectedPackages = (store: Store) =>
  store.misc.selectedPackages;
export const selectValidPromoCode = (store: Store) => store.misc.validPromoCode;
export const selectSubscriptionPrice = (store: Store) =>
  store.misc.subscriptionPrice;
export const selectPoNumber = (store: Store) => store.misc.poNumber;
export const selectFinanceEmail = (store: Store) => store.misc.FinanceEmail;
export const selectUpdateUsersList = (store: Store) =>
  store.misc.updateUsersList;
export const selectPrice = (store: Store) => store.misc.subscriptionPrice;
export const selectShoolDetails = (store: Store) => store.misc.schoolDetails;
export const selectRegistrationToken = (store: Store) =>
  store.misc.registrationToken;
export const selectToastStatus = (store: Store) => store.misc.toastStatus;
